import {LitElement, html, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {property} from 'lit/decorators/property.js';
import {connect} from 'pwa-helpers';
import store from '../../store';

@customElement('summary-specsheet-feature')
export class SummarySpecsheetFeature extends connect(store)(LitElement) {

	static styles = css`
		:host {
			padding: 0;
		}
		.row {
			display: flex;
			padding: 8px 0 8px 0;
			justify-content: flex-start;
			border-bottom: 1px solid #c6c6c6;
		}

		.label {
			display: inline-block;
			font: var(--font-specsheet-bold);
			padding-right: var(--specsheet-feature-padding);
			white-space: nowrap;
			flex: 1;
		}

		.value {
			width: initial;
			min-width: initial;
			padding-right: 0;
			font: var(--font-specsheet-light);
			flex: 2;
		}

	`;

	@property({type: String})
	key = '';

	@property({type: String})
	condition = null;

	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}

	render() {
		if (this.condition?.trim() === '') return null;
		return html`
			<div class="row">
				<span class="label">
					<slot name="label"></slot>
				</span>
				<span class="value">
					<slot name="value"></slot>
				</span>
			</div>
        `;
	}
}
